// extracted by mini-css-extract-plugin
module.exports = {"badge":"_2cEUj_wr6STxkeYeXS9oTC"};